// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d433dc2c","453":"c656d1f0","667":"9921c78f"}[chunkId] + ".chunk.js";
};